export default __webpack_public_path__ + "static/0236-d89f8d156c330c27b6e2c722dbd5a08b.png";